import React from 'react';
import { Link } from 'react-router-dom';
import './OpenedBlock.css';
import SeeAllButton from '../../SeeAllButton/SeeAllButton';




const OpenedBlock = ({ title, children, link }) => {


    return (
        <>
            <div className='openedBlock__container'>
                {/* <div className='openedBlock__header' >
                    <div className='openedBlock__title'>{title}</div>
                  {link && <Link to={link}> <SeeAllButton /></Link>}
                </div> */}
                {children}
            </div>
        </>
    )
}
export default OpenedBlock
